// angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class UploaderService {
  private readonly _http = inject(HttpClient);
  constructor() {}

  public uploadFile(formData: FormData) {
    return this._http.post<any>('uploadFile', formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
